<template>
	<div class="content">
		<div class="menu-bar">
			<div class="container">
				<Menubar></Menubar>
			</div>

		</div>
		<div id="top" class="top">
			<div class="container">
				<p class="title" v-html="l10.All_Features_Body_Title1"></p>
				<p class="subtitle" v-html="l10.All_Features_Body_Title1_Description1"></p>
				<div class="items">

						<div>
							<img src="../../assets/features/img-features-top-icon-1@2x.png"/>
							<p v-html="l10.All_Features_Body_Title1_Description1_Subtitle1"></p>
						</div>
						<div>
							<img src="../../assets/features/img-features-top-icon-2@2x.png"/>
							<p v-html="l10.All_Features_Body_Title1_Description1_Subtitle2"></p>
						</div>
						<div>
							<img src="../../assets/features/img-features-top-icon-3@2x.png"/>
							<p v-html="l10.All_Features_Body_Title1_Description1_Subtitle3"></p>
						</div>
						<div>
							<img src="../../assets/features/img-features-top-icon-4@2x.png"/>
							<p v-html="l10.All_Features_Body_Title1_Description1_Subtitle4"></p>
						</div>
						<div>
							<img src="../../assets/features/img-features-top-icon-5@2x.png"/>
							<p v-html="l10.All_Features_Body_Title1_Description1_Subtitle5"></p>
						</div>
						<div>
							<img src="../../assets/features/img-features-top-icon-6@2x.png"/>
							<p v-html="l10.All_Features_Body_Title1_Description1_Subtitle6"></p>
						</div>

				</div>
			</div>
		</div>
		<div id="article1">
			<div class="container">
				<div class="article">
					<div class="title">
						<img src="../../assets/features/img-features-top-icon-1.png"/>
						<p v-html="l10.All_Features_Body_Title1_Subtitle1">

						</p>

					</div>
					<div class="text">

							<p v-html="l10.All_Features_Body_Title1_Subtitle1_Description1">

							</p>

							<p v-html="l10.All_Features_Body_Title1_Subtitle1_Description2">

							</p>

							<p v-html="l10.All_Features_Body_Title1_Subtitle1_Description3">

							</p>
					</div>
					<router-link to="/curriculum/levelofdailyadventures"><div class="button">
						<span v-html="l10.All_Features_Body_Title1_Subtitle1_Button1"></span>

					</div></router-link>
				</div>
			</div>

		</div>
		<div id="article2">
			<div class="container">
				<div class="article">
					<div class="title">
						<img src="../../assets/features/img-features-top-icon-2.png"/>
						<p v-html="l10.All_Features_Body_Title1_Subtitle2">

						</p>

					</div>
					<div class="text">

							<p v-html="l10.All_Features_Body_Title1_Subtitle2_Description1">

							</p>

							<p v-html="l10.All_Features_Body_Title1_Subtitle2_Description2">

							</p>
					</div>
					<router-link to="/curriculum/games/countingandcardinality"><div class="button">
						<span v-html="l10.All_Features_Body_Title1_Subtitle2_Button1"></span>

					</div></router-link>
				</div>
				<!-- <div id="speechBubble">
					<p v-html="l10.article2BubbleTitle1">

					</p>
					<p v-html="l10.article2BubbleTitle1Des">

					</p>

				</div> -->
			</div>
			<div class="img">
				<div v-for="index in [1,2,3,4,5,6,7,8]">
					<img :src="getFeaturesImgUrl(index)"/>
					<p v-html="getFeaturesImgText(index)">

					</p>
				</div>

			</div>




		</div>
		<div id="article3">
			<div class="container">
				<div class="article">
					<div class="title">
						<img src="../../assets/features/img-features-top-icon-3.png"/>
						<p v-html="l10.All_Features_Body_Title1_Subtitle3">
						</p>

					</div>
					<div class="text">

							<p v-html="l10.All_Features_Body_Title1_Subtitle3_Description1">

							</p>

							<p v-html="l10.All_Features_Body_Title1_Subtitle3_Description2">

							</p>
					</div>
					<router-link to="/curriculum/missions/prekinder"><div class="button">
						<span v-html="l10.All_Features_Body_Title1_Subtitle3_Button1"></span>

					</div></router-link>
				</div>
				<div class="img">
					<img src="../../assets/features/img-features-feature-3-list.png"
					     srcset="../../assets/features/img-features-feature-3-list@2x.png 2x,
					             ../../assets/features/img-features-feature-3-list@3x.png 3x">
					<div class="description">
						<p v-html="l10.All_Features_Body_Title1_Subtitle3_Agegroup1"></p>
						<p v-html="l10.All_Features_Body_Title1_Subtitle3_Agegroup2"></p>
						<p v-html="l10.All_Features_Body_Title1_Subtitle3_Agegroup3"></p>
						<p v-html="l10.All_Features_Body_Title1_Subtitle3_Agegroup4"></p>
						<p v-html="l10.All_Features_Body_Title1_Subtitle3_Agegroup5"></p>
						<p v-html="l10.All_Features_Body_Title1_Subtitle3_Agegroup6"></p>
						<p v-html="l10.All_Features_Body_Title1_Subtitle3_Agegroup7"></p>
						<p v-html="l10.All_Features_Body_Title1_Subtitle3_Agegroup8"></p>

					</div>
				</div>


			</div>

		</div>
		<div id="article4">
			<div class="container">
				<div class="article">
					<div class="title">
						<img src="../../assets/features/img-features-top-icon-4.png"/>
						<p v-html="l10.All_Features_Body_Title1_Subtitle4">

						</p>

					</div>
					<div class="text" >

						<span v-html="l10.All_Features_Body_Title1_Subtitle4_Description1"></span>

					</div>
				</div>

			</div>

		</div>
		<div id="article5">
			<div class="container">
				<div class="article">
					<div class="title">
						<img src="../../assets/features/img-features-top-icon-5.png"/>
						<p v-html="l10.All_Features_Body_Title1_Subtitle5"></p>
					</div>
					<div class="text" >
						<p v-html="l10.All_Features_Body_Title1_Subtitle5_Description1"></p>
						<p v-html="l10.All_Features_Body_Title1_Subtitle5_Description2"></p>
					</div>

					<img src="../../assets/features/img-features-feature-5-i-pad.png"
					     srcset="../../assets/features/img-features-feature-5-i-pad@2x.png 2x,
					             ../../assets/features/img-features-feature-5-i-pad@3x.png 3x">


				</div>
				<div class="article">
					<div class="title">
						<img src="../../assets/features/img-features-top-icon-6.png"/>
						<p v-html="l10.All_Features_Body_Title1_Subtitle6"></p>
					</div>
					<div class="text" >
						<p v-html="l10.All_Features_Body_Title1_Subtitle6_Description1"></p>
						<p v-html="l10.All_Features_Body_Title1_Subtitle6_Description2"></p>
					</div>
					<img src="../../assets/features/img-features-feature-6-i-pad.png"
				     srcset="../../assets/features/img-features-feature-6-i-pad@2x.png 2x,
				             ../../assets/features/img-features-feature-6-i-pad@3x.png 3x">
				</div>

			</div>
		</div>
		<TryTodomathBottom @click-cn-androiddownload="handleClickAndroidDownload"></TryTodomathBottom>

		<div class="container">
			<Footer>

			</Footer>
		</div>


	</div>

</template>
<script>
import Menubar from '../../components/menubar/LaptopLayout.vue'
import TryTodomathBottom from '../../components/footer/TryTodomathLaptop.vue'
import Footer from '@/components/footer/FooterLaptop.vue'


export default {
  name: 'FeaturesLaptopFrame',
	components:{ Menubar,TryTodomathBottom,Footer},
	data () {
			const text = require('../../text/features/laptop.js').default;
			const l10n = text[this.$store.state.lang]?text[this.$store.state.lang]:text['en'];
	    return {
				l10:l10n
	    }
	},
	methods:{
		getFeaturesImgUrl(index){
			return require("@/assets/features/img-features-feature-2-game-"+index+"@2x.png");
		},
		getFeaturesImgText(index){
			return this.l10["All_Features_Body_Title1_Subtitle2_GameName"+index];
		},
		handleClickAndroidDownload() {
			this.$emit('click-cn-androiddownload')
		}
	}
}
</script>
<style  scoped>
.content{
	width:100%;
	overflow: hidden;
}

.container{
	margin: 0 auto;
	height: auto;
	min-height: 100px;
		width:1024px;
}

#top{
	width: 100%;
	height: 1010px;
	background-image: url('../../assets/features/img-features-top-bg.png');
	background-size: 2400px 1010px;
	background-repeat: no-repeat;
	background-position: center;
	color:#fff;
	padding-top: 196px;
}

.top .title{
	font-size: 76px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.16;
  letter-spacing: -3px;
  text-align: center;
  color: #ffffff;

}
.top .subtitle{
	font-size: 32px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;
  letter-spacing: -0.7px;
  text-align: center;
  color: #ffffff;
  margin-top: 16px;
}

.top .items{
	padding:0 60px;
	margin-top: 100px;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
}
.top .items>div{
	display: flex;
	flex-direction: column;
	align-content: space-between;
	width: 260px;
	height: 158px;
	margin-bottom: 60px;
}
.top .items>div img{
	width: 128px;
	height: auto;
	margin-bottom: 16px;
	align-self: center;
}
.top .items>div p{
	font-size: 22px;
     font-weight: bold;
     font-style: normal;
     font-stretch: normal;
     line-height: 1.45;
     letter-spacing: -0.5px;
     text-align: center;
     color: #ffffff;
}
.article{
	text-align: left;
}

.article .title{
	font-size: 42px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: -1.8px;
  overflow: hidden;
  display: flex;
    align-items: center;

}
.article .title>img{
	width: 63.7px;
	height: auto;
}
.article .title>p{
	width: 370px;
	margin-left: 11px;
}
.article .text{
	font-size: 22px;
 font-weight: normal;
 font-style: normal;
 font-stretch: normal;
 line-height: 1.45;
 letter-spacing: -0.9px;

 overflow: hidden;
 margin-top: 36px;
}
.article .text>p{
	margin-bottom: 28px;
	padding-left: 30px;
}
.article .text>p:last-of-type{
	margin-bottom: 0px;
}
.article .text p::before{
	content:url("../../assets/features/icon-text-el-blk.svg");
	position: absolute;
	transform: scale(0.8) translateX(-25px) translateY(-3px);
}

.article .button{
	margin-top:60px;
  width: 317px;
  height: 64px;
  border-radius: 36px;
  border: solid 3px #fff;
	text-align: center;
	font-size: 22px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 59px;
  letter-spacing: -1px;
  text-align: center;
  color: #fff;
  margin-right: 0;
  display: inline-block;
}
.article  .button::after{
	content:url('../../assets/features/img-btn-arrow-wh.svg');
	position: relative;
	padding-left: 5px;
	display: inline-block;
	transform: scale(0.85);
	top: 3px;

}

#article1{
	height:984px;
	background-image: url('../../assets/features/img-features-feature-1-bg@2x.jpg');
	background-size: auto 1122px;
	background-repeat: no-repeat;
	background-position: center;
	padding-top:164px;
	z-index: -10;

}
#article1 .article {
	width:430px;
	margin-left:11px;
	 color: #41403e;

}
#article2{
	height:1128px;
	background-image: url('../../assets/features/img-features-feature-2-bg.png');
	background-size: 2400px auto;
	background-repeat: no-repeat;
	background-position: center;
	margin-top: -190px;
	z-index: 100;
	padding-top: 248px;
	position: relative;

}
#article2 .container{
	position: relative;
}
#article2 .article {

	color: #fff;
}
#article2 .article .text p::before{
	content:url('../../assets/features/icon-text-el-wh.svg');
}
#article2 .article .button{
	color: #3b5a29;
	border: solid 3px #3b5a29;

}
#article2  .article  .button::after{
	content:url('../../assets/features/icon-btn-arrow-gr.svg');
}
#article2 #speechBubble{
	background-image: url('../../assets/features/img-features-feature-2-infobox.svg');
	width: 440px;
  height: 241px;
	position: absolute;
	top:115px;
	left:calc(50% - 60px);
	transform: translateX(-100%);
}
#article2 #speechBubble p:first-of-type{
	font-size: 42px;
 font-weight: bold;
 font-style: normal;
 font-stretch: normal;
 line-height: normal;
 letter-spacing: -1.8px;
 text-align: center;
 color: #fff9b8;
	margin-top:30px;
}
#article2 #speechBubble p:last-of-type{
	margin-top: 5px;
	font-size: 22px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.45;
  letter-spacing: -1px;
  text-align: center;
  color: #75bd40;
}
#article2>img{
	margin-top:46px;
	position: absolute;
	left: 50%;
	transform: translateX(-50%);

}
#article2>.img{
	width: 2306px;
	position: relative;
	left:50%;
	transform: translateX(-50%);
	display: flex;
	justify-content: space-between;
	margin-top:80px;
}
#article2>.img>div{
	width:248px;
	position: relative;
}
#article2>.img>div>img{
	width: 100%;
}
#article2>.img>div>p{
	position: absolute;
	width:220px;
	left:50%;
	transform: translateX(-50%);
	top:11.8px;
	font-size: 17px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.5px;
  text-align: center;
  color: #fff9b8;
}
#article3{
	margin-top:-100px;
	background-color: #fffcf7;
	padding-top: 253px;
	height:1077px;
}
#article3 .article .button{
	color: #ffcc24;
	border: solid 3px #ffcc24;

}
#article3  .article  .button::after{
	content:url('../../assets/features/icon-btn-arrow-yl.svg');
}
#article3 .container{
	position: relative;
}
#article3 .container>.img{
	position: absolute;
    top: -55px;
    width: 1030px;
    left: 578px;
}
#article3 .container>.img>.description{
	position: absolute;
	z-index: 10;
	top:-3px;
	left:131.2px;
	font-size: 32px;
	  font-weight: bold;
	  font-style: normal;
	  font-stretch: normal;
	  letter-spacing: -0.7px;
	  color: #41403e;
}
#article3 .container>.img>.description>p{
	line-height: 104px;
}
#article4 {
	background-image: url('../../assets/features/img-features-feature-4-monsters@2x.png'),url('../../assets/features/img-features-feature-4-bg.png');
	background-size:  1205px auto, 2400px auto;
	background-repeat: no-repeat;
	background-position: center 443px, center ;
	height: 1110.8px;
	margin-top:-121px;
	z-index: 1;
	position: relative;
	padding-top:239px;
}

#article4 .article {
	margin-left:531px;
	color:#fff;

}
#article5 .container{
	display: flex;
	padding-top:104px;
		padding-bottom: 180.5px;
}
#article5 .article{
	display: inline-block;
	align-self: flex-start;
}
#article5 .article:first-of-type{
	margin-left:11px;
}

#article5 .article:last-of-type{
	margin-left:19px;
}
#article5 .article>img{
	position: relative;
	width: 587.2px;
	  height: 448.8px;
	  object-fit: contain;
	  transform: rotate(-4deg);
}
#article5 .article:first-of-type>img{
	margin-left: -115px;
	margin-top:70.7px;
}
#article5 .article:last-of-type>img{
	margin-top:133.7px;
}
</style>



// WEBPACK FOOTER //
// src/pages/features/FeaturesLaptop.vue